'use client';

import { cn } from '@/lib/utils';

export function SheetSlideSection({
  open,
  children,
  className,
  panelClassName,
  bleed = false,
}: {
  open: boolean;
  children: React.ReactNode;
  className?: string;
  panelClassName?: string;
  /** Cancel parent sheet horizontal padding so the panel spans edge to edge. */
  bleed?: boolean;
}) {
  return (
    <div
      className={cn(
        'grid transition-[grid-template-rows] duration-300 ease-out',
        open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        bleed && '-mx-1.5',
        className,
      )}
      aria-hidden={!open}
    >
      <div className="min-h-0 overflow-hidden">
        <div
          className={cn(
            'flex flex-col gap-1 bg-gray-50 shadow-inner dark:bg-gray-900/30',
            panelClassName,
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
